import { Helmet } from 'react-helmet-async';
import { Stack, Container, Typography, Button, Dialog, Grid, Card, Box, styled } from '@mui/material';
import { useState } from 'react';
import Slider from 'react-slick';
import SellItem from '../sections/@dashboard/marketplace/SellItem';
import useGetMarketPlace from '../hooks/useGetMarketPlace';
import { fNumber } from '../utils/formatNumber';
import buildingCategories from '../_mock/buildingCategories';
import { auth } from '../firebase';
import VIewItem from '../sections/@dashboard/marketplace/VIewItem';
import CompareItems from '../sections/@dashboard/marketplace/CompareItems';

// ----------------------------------------------------------------------

export default function Marketplace() {

    const market = useGetMarketPlace()
   
    const [openView, setopenView] = useState(false)
    const [filtered, setfiltered] = useState(null)
    const [selectedCategory, setselectedCategory] = useState(null)
     const [selectedItem, setselectedItem] = useState(null)
   
   
      const handleClickOpenView = (ex) => {
        setopenView(true);
        setselectedItem(ex)
      };
    
      const handleCloseView = (ex) => {
        setopenView(false);
        setselectedItem(ex)
      };

      const StyledProductImg = styled('img')({
        top: 0, bottom:0, left:0, right:0, 
        
      });

     

      const settings2 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        
      };

      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      };

      function filterItemsByCategory(selectedCategory) {
        setselectedCategory(selectedCategory)
             const filteredItems = market?.filter(item => item.category === selectedCategory);
        setfiltered(filteredItems)
        
      }
  const [compare, setcompare] = useState([])

      const addToCompare = (item)=>{
        setcompare([...compare, item])
      }
     
      const removeFromCompare = (itemIdToRemove) => {
        const updatedCompare = compare.filter((item) => item.id !== itemIdToRemove);
        setcompare(updatedCompare);
      };
      console.log(compare)
  return (
   <>
      <Helmet>
        <title> Home</title>
      </Helmet>

    
      
      <Dialog
        open={openView}
        onClose={handleCloseView}
      ><VIewItem handleClose={handleCloseView} data={selectedItem} />
      </Dialog>


      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Marketplace
          </Typography>  
        </Stack> 

        <Stack sx={{mb:4}}>
        <Slider {...settings}>
          {buildingCategories.map((bc, index)=>(
            <div key={index}>
              <Card sx={{p:2, m:1}}  onClick={()=>filterItemsByCategory(bc.name)}>
              <Stack alignItems={"center"} justifyContent={"center"}>
                <Typography>{bc.name}</Typography>
              </Stack>
              </Card>
              </div>
          ))}
        </Slider>
</Stack>

{compare.length > 0 && <CompareItems items={compare} removeItem={removeFromCompare}/>}

<Stack sx={{my:3}}>
<Typography variant='h4'>{selectedCategory && selectedCategory}</Typography>
</Stack>
 <Grid container spacing={3}>
    {filtered ? filtered.length === 0 ? 
      <Stack sx={{my:3, p:3}}><Typography variant='h6'>No results found.</Typography></Stack> : filtered?.map((m, index)=>(
      <Grid item xs={12} md={4} key={index}>
            <Card >
                <Box>
                <Slider {...settings2}>
                    {m.images?.map((i, index)=>(
                      <StyledProductImg key={index} alt={m.name} src={i} />
                    ))}
                </Slider>
                    <Stack spacing={2} sx={{p:2}}>
                         <Typography variant="h5">{fNumber(m.price)}
                        <Typography component="span"> {m.type}</Typography></Typography>
                        <Stack direction="row" justifyContent={"space-between"}>
                            <Typography>{m.name}</Typography>
                            <Typography>{m.condition}</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={"row"} sx={{my:2, mb:2}} justifyContent={"space-between"} >
                    {compare.length ===2 ? null :
                      <Button variant='outlined' color='success' onClick={()=>addToCompare(m)}>Compare</Button>}
                      <Button variant='contained' color='success' onClick={()=>handleClickOpenView(m)}>View</Button>
                    </Stack>
                </Box>
            </Card>
        </Grid>
    )) :  market?.map((m, index)=>(
        <Grid item xs={12} md={4} key={index}>
            <Card >
                <Box>
                <Slider {...settings2}>
                    {m.images?.map((i, index)=>(
                      <StyledProductImg key={index} alt={m.name} src={i} />
                    ))}
                </Slider>
                    <Stack spacing={2} sx={{p:2}}>
                         <Typography variant="h5">{fNumber(m.price)}
                        <Typography component="span"> {m.type}</Typography></Typography>
                        <Stack direction="row" justifyContent={"space-between"}>
                            <Typography>{m.name}</Typography>
                            <Typography>{m.condition}</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={"row"} sx={{mx:2, mb:2}}  justifyContent={"space-between"} >
                      {compare.length ===2 ? null :
                      <Button variant='outlined' color='success' onClick={()=>addToCompare(m)}>Compare</Button>}
                      <Button variant='contained' color='success' onClick={()=>handleClickOpenView(m)}>View</Button>
                    </Stack>
                </Box>
            </Card>
        </Grid>
    ))}
 </Grid>
      </Container>
    </>
  );
}
